// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-MenuButton_cls1__cR9QP","cls2":"VeloSplitFab-MenuButton_cls2__txGSb VeloSplitFab-MenuButton_cls1__cR9QP"};